import type {IMenuItem} from "@torim-app/types";
import {ClientFeatures} from "@torim-app/types";
import {AdminRouteNames} from "@app/router/route-names";

export const adminMenuItems: Array<IMenuItem> = [
  {
    icon: 'pi-home',
    name: AdminRouteNames.Home,
    actionButton: [
      {icon: 'pi-sync', function: 'refresh', id: 'refresh'},
      {icon: 'pi-bell', function: 'openNotifications', id: 'open-notifications'},
    ],
    title: 'דף הבית',
    onlyAdmin: false,
  },
  {
    icon: 'pi-id-card',
    name: AdminRouteNames.BusinessConfigurations,
    title: 'שירותים ושעות פעילות',
    onlyAdmin: false,
  },
  {
    icon: 'pi-users',
    name: AdminRouteNames.Clients,
    title: 'לקוחות ומשובים',
    onlyAdmin: false,
  },
  {
    icon: 'pi-bolt',
    name: AdminRouteNames.Communication,
    title: 'אוטומציות',
    onlyAdmin: true,
  },
  {
    icon: 'pi-send',
    name: AdminRouteNames.Campaigns,
    title: 'קמפיין הודעות',
    onlyAdmin: true,
  },
  {
    icon: 'pi-percentage',
    name: AdminRouteNames.Vouchers,
    title: 'שוברים, כרטיסיות וקופונים',
    onlyAdmin: true,
    relatedFeature: ClientFeatures.Vouchers,
  },
  {
    icon: 'pi-shopping-bag',
    name: AdminRouteNames.Shop,
    title: 'מכירת מוצרים',
    actionButton: [{icon: 'pi-plus', function: 'addNewShopItem', title: 'הוספת מוצר', id: 'add-product'}],
    onlyAdmin: true,
    relatedFeature: ClientFeatures.Shop
  },
  {
    icon: 'pi-verified',
    name: AdminRouteNames.LoyaltyProgram,
    title: 'מועדון לקוחות',
    onlyAdmin: true,
    relatedFeature: ClientFeatures.LoyaltyProgram
  },
  {
    icon: 'pi-file',
    name: AdminRouteNames.ConsentForms,
    title: 'מסמכים ואישורים',
    onlyAdmin: true,
  },
  {
    icon: 'pi-chart-line',
    name: AdminRouteNames.Analytics,
    title: 'ניתוחי מידע',
    onlyAdmin: true,
  },
  {
    icon: 'pi-shield',
    name: AdminRouteNames.Reports,
    title: 'דוחות וביקורת מס',
    onlyAdmin: true,
  },
  {
    icon: 'pi-wallet',
    name: AdminRouteNames.Payments,
    title: 'כספים וסליקה',
    onlyAdmin: true,
  },
  {
    icon: 'pi-cog',
    name: AdminRouteNames.Configurations,
    title: 'העדפות',
  },
  {
    icon: 'pi-link',
    name: AdminRouteNames.Integrations,
    title: 'חיבורים',
    onlyAdmin: true,
  },
  {
    icon: 'pi-whatsapp',
    name: 'contact-us',
    title: 'צרו קשר',
  },
  {
    icon: 'pi-sign-out',
    name: 'logout',
    title: 'התנתקות',
    onlyAdmin: false,
  },
  {
    icon: '',
    name: AdminRouteNames.ClientProfile,
    actionButton: [
      {icon: '', function: 'goBackToClients', title: 'חזרה', onlyAdmin: false, id: ''},
    ],
    title: '',
    isSubPage: true,
  },
];
